<script>
import { subscriptionStatusKeys } from '@/modules/profiles/enum/SubscriptionStatusEnum'
import { projectUrl } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
export default {
  name: 'SubscriptionPreferenceChannel',

  props: {
    channel: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      subscriptionStatusKeys
    }
  },

  computed: {
    channelName() {
      if (this.channel.name) return this.channel.name

      const value = this.getStatusValue()

      if (value === subscriptionStatusKeys.Unsubscribed) {
        return this.$t('SubscriptionPreferenceChannel_Unsubscribed')
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return this.$t('SubscriptionPreferenceChannel_Subscribed')
      } else if (value === subscriptionStatusKeys.Undefined) {
        return this.$t('SubscriptionPreferenceChannel_Undefined')
      }
    },

    wrapperComponent() {
      if (!this.channel.id) return 'div'

      return 'el-dropdown'
    }
  },

  methods: {
    getSubscriptionIcon() {
      if (!this.channel.id) {
        return 'el-icon-empty-icon empty-icon el-icon-disabled'
      }

      const value = this.getStatusValue()

      if (value === subscriptionStatusKeys.Unsubscribed) {
        return 'el-icon-error'
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return 'el-icon-success'
      } else if (value === subscriptionStatusKeys.Undefined) {
        return 'el-icon-remove'
      }
    },

    getStatusValue() {
      if (Number.isInteger(this.channel.subscription)) {
        return this.channel.subscription
      }

      return parseInt(this.channel.subscription || '2')
    },

    handleCommand(command) {
      switch (command) {
        case 'OpenSubscriptionLog':
          this.$emit('open-audit-log', this.channel)
          break
        case 'Subscribe':
          this.updateSubscription(this.channel.id, 1)
          break
        case 'Unsubscribe':
          this.updateSubscription(this.channel.id, 0)
          break
      }
    },

    updateSubscription(preferenceId, newValue) {
      RestApi.patch(
        projectUrl(
          `profiles/${this.$route.query.profile_id}/consent-preferences`
        ),
        {
          preferenceId: preferenceId,
          status: newValue
        }
      )
        .then(() => {
          this.$message({
            message: this.$t('Profiles_Channels_UpdateSuccessMessage'),
            type: 'success'
          })

          this.$emit('reload-preferences')
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<template>
  <component
    :is="wrapperComponent"
    trigger="click"
    placement="bottom"
    @command="handleCommand"
    :class="channel.id ? 'click-allowed' : 'click-not-allowed'"
  >
    <div class="status-container">
      <i class="status-icon" :class="getSubscriptionIcon()"></i>
      <span class="channel-name" :class="{ disabled: !channel.id }">
        {{ channelName }}
      </span>
    </div>
    <el-dropdown-menu v-if="channel.id">
      <el-dropdown-item
        v-if="getStatusValue() !== subscriptionStatusKeys.Subscribed"
        command="Subscribe"
      >
        {{ $t('Profiles_Channels_Action_Subscribe') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="getStatusValue() !== subscriptionStatusKeys.Unsubscribed"
        command="Unsubscribe"
      >
        {{ $t('Profiles_Channels_Action_Unsubscribe') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="
          $hasFeature('auditLogProfile') &&
            getStatusValue() !== subscriptionStatusKeys.Undefined
        "
        command="OpenSubscriptionLog"
      >
        {{ $t('Profiles_Channels_Action_Audit_Log') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </component>
</template>

<style scoped>
.status-container {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;

  .status-icon {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    font-size: 18px;
  }

  .empty-icon {
    background: #e6e6e6;
  }

  .el-menu-item {
    cursor: default;
  }

  .el-icon-success {
    color: #1fca10;
  }

  .el-icon-error {
    color: #f56c6c;
  }

  .el-icon-remove {
    color: #a7acba;
  }

  .el-icon-disabled {
    color: #ebeef5;
  }

  .channel-name.disabled {
    color: #ebeef5;
  }
}
.click-allowed {
  cursor: pointer;
}
.click-not-allowed {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/SubscriptionPreferenceChannel.vue